$(window).on("load scroll", function() {
    var $section = $(".interactive-plan");

    window.isScrolledIntoView = animations._isScrolledIntoView($section);
    if(window.isScrolledIntoView === true && !$(".ip-markers").hasClass("playAnimations")) {
        animations.playAnimations();
    }
});

$(function() {
    animations.init();
});